import {FilterListForm} from 'common/pages/filter-list/FilterListForm'

export const FilterListFormAdmin = (props: any) =>
    <FilterListForm {...props} mode={props.mode} admin />